module.exports = __webpack_public_path__ + "static/media/6ea5fa46-5311-450b-8744-288a30c55348.eea8d6d7.woff2";